import React from "react";
import { Route, Routes } from "react-router-dom";
import { Container, Row, Col } from "shards-react";

import MainNavbar from "./MainNavbar/MainNavbar";
import MainSidebar from "./MainSidebar/MainSidebar";

const CommonpageLayout = ({ noNavbar, routes = [] }) => (
  <Container fluid>
      <Row>
      {!noNavbar && <MainSidebar />}
        <Col
          className="main-content p-0"
          lg={{ size: 10, offset: 2 }}
          md={{ size: 9, offset: 3 }}
          sm="12"
          tag="main"
        >
         {!noNavbar && <MainNavbar />}
          <Routes>
            {(routes || []).map((route, index) => (
              <Route
                key={"route-" + index}
                path={route.path}
                element={route.element}
              />
            ))}
          </Routes>
        </Col>
      </Row>
    </Container>
);

export default CommonpageLayout;
